module.exports = __webpack_public_path__ + "img/selected-telemedicine.f05230db.svg";